import { type ButtonHTMLAttributes, type ReactNode } from "react";
import { useInterruptCard } from "../InterruptCardContext";

/**
 * Reject button — submits `{ type: "ignore", args: null }`. Maps to our
 * "reject this action; agent keeps helping" semantic, NOT to "abandon
 * the thread" (which is a separate Rails-side action). Renders null when
 * `interrupt.config.allow_ignore` is false.
 */
export interface RejectProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
}

export function Reject({ children, onClick, ...props }: RejectProps) {
  const { interrupt, submit, submitting } = useInterruptCard();
  if (!interrupt.config.allow_ignore) return null;

  return (
    <button
      type="button"
      {...props}
      disabled={props.disabled || submitting}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented) return;
        void submit({ type: "ignore", args: null });
      }}
      className={[
        "px-3 py-1.5 text-sm font-medium rounded-md",
        "bg-white text-zinc-900 border border-zinc-300 hover:bg-zinc-50",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        props.className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children ?? "Reject"}
    </button>
  );
}
